import { ChangeDetectionStrategy, Component, inject, Injector, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WithActivatedRoute, WithRouter, WithStaticBackNavigation, WithTitle } from '@softline/application';
import { PageComponent, PageHeaderComponent } from '@softapps/core';
import { I18nModule, UiCoreModule } from '@softline/ui-core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'soft-overview',
    imports: [CommonModule, I18nModule, RouterLink, UiCoreModule, PageComponent, PageHeaderComponent],
    templateUrl: './overview.component.html',
    styleUrl: './overview.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewComponent extends
  WithTitle(
    WithStaticBackNavigation('/',
      WithRouter(
        WithActivatedRoute()
      )
    )
  )
implements OnInit {
  private readonly injector = inject(Injector);
  readonly title = signal("#WIEGUNG.TITLE");

  constructor() {
    super();
  }

  override async ngOnInit(): Promise<void> {
    super.ngOnInit();
  }
}
